import { Checkbox, Form, Input, Radio } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox';
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from 'react';
import { CommonButton } from '../../../../../../components/button/main';
import { ConsoleForm } from '../../../../../../components/form';
import { CommonSelect } from '../../../../../../components/select';
import getFormatMessage from '../../../../../../locales/get-format-message';
import {
  IAPIFeeCenterMailManageItem,
  IAPIStudioMemberHasPermissionItem,
} from '../../../../../../model/api-modules';
import {
  IInvoiceTypeData,
  IInvoiceTypeFormData,
  InvoiceBuyerSeller,
  InvoiceShow,
} from '../../../../../../model/billing-center/invoice';
import styles from './index.module.scss';
import arrowIcon from '../../../../../../assets/svg/arrow-right-up.svg';
import { InvoiceEmailDrawer } from '../../emails/drawer';

interface IProps {
  readonly owner: IAPIStudioMemberHasPermissionItem;
  readonly emails: ReadonlyArray<IAPIFeeCenterMailManageItem>;
  readonly onChange: (
    data: IInvoiceTypeData,
    emails: IAPIFeeCenterMailManageItem[]
  ) => void;
  readonly values: IInvoiceTypeData;
}

export const HeaderTypeForm = (props: IProps) => {
  const { owner, emails, onChange, values } = props;

  const formInfoRef = useRef<IInvoiceTypeData>(values);

  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const emailOptions = emails.map((email) => ({
    label: email.email,
    value: email.email,
  }));
  const [form] = useForm<IInvoiceTypeFormData>();

  useEffect(() => {
    if (!values) {
      return;
    }

    form.setFieldsValue({
      email: values.email,
      show_buyer_seller: [
        values.show_buyer === InvoiceShow.Show && InvoiceBuyerSeller.Buyer,
        values.show_seller === InvoiceShow.Show && InvoiceBuyerSeller.Seller,
      ].filter(Boolean) as InvoiceBuyerSeller[],

      remark: values.remark,
    });
  }, [values]);

  const renderModifyModal = () => {
    if (showDrawer) {
      return (
        <InvoiceEmailDrawer
          onClose={() => setShowDrawer(false)}
          onChange={(emails) => {
            onChange(formInfoRef.current, emails);
          }}
          owner={owner}
        />
      );
    }
  };

  return (
    <>
      <ConsoleForm
        form={form}
        className={styles.headerTypeForm}
        onValuesChange={(changedValues, allValues: IInvoiceTypeFormData) => {
          const info = {
            email: allValues.email,
            show_buyer: allValues.show_buyer_seller?.includes(
              InvoiceBuyerSeller.Buyer
            )
              ? InvoiceShow.Show
              : InvoiceShow.Hide,

            show_seller: allValues.show_buyer_seller?.includes(
              InvoiceBuyerSeller.Seller
            )
              ? InvoiceShow.Show
              : InvoiceShow.Hide,
            remark: allValues.remark || '',
          };
          formInfoRef.current = info;
          onChange(info, [...emails]);
        }}
      >
        <Form.Item
          label={
            <Radio checked={true}>
              {getFormatMessage('apply_electronic_invoice')}
            </Radio>
          }
          name="show_buyer_seller"
        >
          <BuyerSellerChecks />
        </Form.Item>
        <Form.Item label={getFormatMessage('apply_receive_email')} name="email">
          <CommonSelect
            style={{ width: 400 }}
            defaultValue={emails[0]?.email}
            options={emailOptions}
            showSearch={true}
            after={
              <CommonButton type="link" onClick={() => setShowDrawer(true)}>
                {getFormatMessage('email_manage')}
                <img style={{ width: 16 }} src={arrowIcon} />
              </CommonButton>
            }
          />
        </Form.Item>
        <Form.Item
          label={getFormatMessage('apply_invoice_remarks_optional')}
          name="remark"
        >
          <Input.TextArea style={{ width: 400 }} maxLength={200} />
        </Form.Item>
      </ConsoleForm>
      {renderModifyModal()}
    </>
  );
};

const BuyerSellerChecks = (props: CheckboxGroupProps) => {
  return (
    <div>
      <span>{getFormatMessage('invoice_electron_info')}</span>
      <Checkbox.Group
        {...props}
        options={[
          {
            label: getFormatMessage('invoice_show_buyer'),
            value: InvoiceBuyerSeller.Buyer,
          },
          {
            label: getFormatMessage('invoice_show_seller'),
            value: InvoiceBuyerSeller.Seller,
          },
        ]}
      />
    </div>
  );
};
